<section class="master_signup_section">
	<!-- signup_top_row -->
	
	<div class="signup_deyails_box">
		<section class="subscriber_detailform_sec">
			<div class="signup_wrapper">
				<div class="signup_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
					fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch">
					
					<!-- FIELDS-COLUMN -->
					<div class="signup_column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
						fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
						<div class="subscriber_detailform_form">
								  <!-- Step Indicators -->
								  <div class="step-indicator" *ngIf="currentStep > 1">
									<div class="step"  class="step" 
									[class.completed]="currentStep > 1"	[class.active]="currentStep === 1" (click)="goToStep(1)">Step 1: Account</div>
									<div class="step" [class.completed]="currentStep > 2" [class.active]="currentStep === 2" [class.disabled]="currentStep < 2" (click)="goToStep(2)">Step 2: Profession</div>
									<div class="step"  [class.completed]="currentStep > 3"	[class.active]="currentStep === 3"	[class.disabled]="currentStep < 3" (click)="goToStep(3)">Step 3: Location</div>
								  </div>
								  <div class="centerAlignment">
									<div class="itemCenter">
							<div class="title" *ngIf="currentStep==1">
								<img src="../../../../../assets/images2/logo-login.svg" alt="img">
								<h2>Create your account to start your journey.</h2>
								
							  </div>
							  <div class="title" style="text-align: left;" *ngIf="currentStep==2">
								<h1>Know Your Role</h1>
								<h2>Understand your responsibilities and how you fit into the team.</h2>
								
							  </div>
							  <div class="title"  style="text-align: left;"  *ngIf="currentStep==3">
								<h1>Your practice details</h1>
								<h2>Dental professional details form</h2>
								
							  </div>
								<form [formGroup]="signUpDetailsForm" class="form-section" #signupFormClear="ngForm" *ngIf="signUpDetails">
  
						
						  
							  <!-- Step 1: Basic Info -->
							  <div class="step-content" *ngIf="currentStep === 1"  [@stepTransition]="animationState">
								<ul class="signup_ul_form">
								  <li>
									<div class="custom-form-group">
									  <div class="custom-form-control">
										<label >Name <span class="star">*</span></label>
										<mat-form-field appearance="outline">
										  <input matInput placeholder="Enter your Name" formControlName="name" (keypress)="allowOnlyAlphabets($event)" >



 
										</mat-form-field>
										<div class="errorMsg"  *ngIf="name.invalid && (name.dirty || name.touched)">
											<span *ngIf="name.errors?.required">Name is required</span>
											<span *ngIf="name.errors?.pattern">Enter only alphabets</span>
										  </div>
									  </div>
									</div>
								  </li>
								  <li>
									<div class="custom-form-group">
									  <div class="custom-form-control">
										<label >Email <span class="star">*</span></label>
										<mat-form-field appearance="outline">
										  <input type="email" matInput placeholder="Enter your Email" formControlName="email">
									 
										</mat-form-field>
										<div class="errorMsg"  *ngIf="email.invalid && (email.dirty || email.touched)">
											<span *ngIf="email.errors?.required">Email is required</span>
											<span *ngIf="email.errors?.email">Enter a valid email</span>
										  </div>
									  </div>
									</div>
								  </li>
								
								  <li>
									<div class="custom-form-group">
									  <div class="custom-form-control">
										<label >Password <span class="star">*</span></label>
										<mat-form-field appearance="outline">
										  <input [type]="passwordShow ? 'text' : 'password'" matInput 
												 placeholder="Enter your password" formControlName="password">
									 
									
										</mat-form-field>
											  <span class="view-password" (click)="viewPassword()" matSuffix>
											<mat-icon>{{passwordShow ? 'visibility' : 'visibility_off'}}</mat-icon>
										  </span>
										<div class="errorMsg"  *ngIf="password.invalid && (password.dirty || password.touched)">
											<span *ngIf="password.errors?.required">Password is required</span>
											<span *ngIf="password.errors?.minlength">Minimum 6 characters</span>
										  </div>
									  </div>
									</div>
								  </li>
								  <li>
									<div class="custom-form-group">
									  <div class="custom-form-control">
										<label >Confirm password <span class="star">*</span></label>
										<mat-form-field appearance="outline">
										  <input [type]="confirmPassShow ? 'text' : 'password'" matInput 
												 placeholder="Confirm password" formControlName="confirmPassword">
								 
										  
										</mat-form-field>
										<span class="view-password" (click)="viewCinfirmPassword()" matSuffix>
											<mat-icon>{{confirmPassShow ? 'visibility' : 'visibility_off'}}</mat-icon>
										  </span>
										  <div class="errorMsg" *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">
											<span *ngIf="confirmPassword.errors?.required">Confirm password is required</span>
											<span *ngIf="confirmPassword.errors?.mismatch && !confirmPassword.errors?.required">
											  Passwords don't match
											</span>
										  </div>
									  </div>
									</div>
								  </li>
								</ul>
							  </div>
						  
							  <!-- Step 2: Profession Type -->
							  <div class="step-content" *ngIf="currentStep === 2"  [@stepTransition]="animationState">
								<ul class="signup_ul_form">
								  <li>
									<div class="custom-form-group business_type_group">
									  <label style="font-weight: bold;">
										What’s your current role?
									  </label>
									  <div class="custom-form-control" style="position: relative;">

										<mat-tab-group [disableRipple]="true" (selectedTabChange)="onTabChange($event)">
											<!-- Dynamic Business Type Tabs -->
											<mat-tab *ngFor="let busiType of typeBus">
											  <ng-template mat-tab-label>
												{{busiType?.name}}
											  </ng-template>
											  
											  <section class="tabs-body">
												<mat-button-toggle-group 
												  formControlName="professionType"
												  class="profession-toggle-group"
												 >
												  
												  <mat-button-toggle [value]="busi.name" class="profession-toggle" 
													*ngFor="let busi of busiType?.directory_categories">
													<span>{{busi?.name}}</span>
												  </mat-button-toggle>
												</mat-button-toggle-group>
												<div class="errorMsg" *ngIf="signUpDetailsForm.hasError('professionOrCustomRequired')">
											  <span>Please select a profession type or enter a custom value</span>
										  		</div>
											  </section>
											</mat-tab>
										  
											<!-- "Others" Tab -->
											<mat-tab >
											  <ng-template mat-tab-label>
												Others
											  </ng-template>
											  
											  <section class="tabs-body">
												<mat-form-field appearance="outline">
												  <input matInput formControlName="customBusinessType" 
														 placeholder="Enter your business type">
														 <div class="errorMsg" *ngIf="signUpDetailsForm.hasError('businessNameRequired')">
															<span>Please select a profession type or enter a custom value</span>
																</div>
												</mat-form-field>
											  </section>
											</mat-tab>
										  </mat-tab-group>











									</div>
									</div>
								  </li>
								
								</ul>
							  </div>
						  
							  <!-- Step 3: Location Info -->
							  <div class="step-content" *ngIf="currentStep === 3"  [@stepTransition]="animationState">
								<ul class="signup_ul_form">
									<li *ngIf="subPlanDetails?.type =='SUPPLIER' || subPlanDetails?.type =='PRACTICE'" style="width: 100%;">
										<div class="custom-form-group">
										  <label >Business Name <span class="star">*</span></label>
										  <div class="custom-form-control">
											<mat-form-field appearance="outline">
											  <input matInput placeholder="Enter business Name" formControlName="businessName">
											 
											</mat-form-field>
											<div class="errorMsg" *ngIf="businessName.invalid && (businessName.dirty || businessName.touched)">
												<span>Business name is required</span>
											</div>
										  </div>
										</div>
									  </li>
									  <li style="width: 100%;">
										<div class="custom-form-group">
										  <label>Phone No <span class="star">*</span></label>
										  <div class="custom-form-control">
											<mat-form-field appearance="outline">
											  <input matInput placeholder="Enter phone no" formControlName="phone" maxlength="10">
											
											</mat-form-field>
											<div class="errorMsg" *ngIf="phone.invalid && ( phone.dirty || phone.touched )">
												<span>State is required</span>
											</div>
										  </div>
										</div>
									  </li>
								  <li>
									<div class="custom-form-group">
									  <label>State <span class="star">*</span></label>
									  <div class="custom-form-control">
										<mat-form-field appearance="outline">
										  <input matInput placeholder="Enter state" formControlName="state">
										
										</mat-form-field>
										<div class="errorMsg" *ngIf="state.invalid && (state.dirty || state.touched)">
											<span>State is required</span>
										</div>
									  </div>
									</div>
								  </li>
								  <li>
									<div class="custom-form-group">
									  <label>Post code <span class="star">*</span></label>
									  <div class="custom-form-control">
										<mat-form-field appearance="outline">
										  <input type="text" matInput placeholder="Enter Zip code" formControlName="postal_code">
										 
										</mat-form-field>
										<div class="errorMsg" *ngIf="postal_code.invalid && (postal_code.dirty || postal_code.touched)">
											<span>Post code is required</span>
										</div>
									  </div>
									</div>
								  </li>
								  <li style="width: 100%;">
									<div class="custom-form-group">
									  <mat-checkbox [(ngModel)]="termAndConditionCheck" [ngModelOptions]="{standalone: true}">
										I agree to the Terms and Conditions
									  </mat-checkbox>
									</div>
								  </li>
								</ul>
							  </div>
						  
							  <!-- Navigation Buttons -->
							  <div class="subscriber_stepper_btn" style="margin-top: 20px;">
								<button *ngIf="currentStep > 1" mat-button class="global-btn btnGray" 
										(click)="previousStep()">Go Back</button>
								
								<button *ngIf="currentStep < 3 && subPlanDetails?.type !== 'SUPPLIER'" mat-button class=" global-btn" style="width:100%"
										(click)="nextStep()" [disabled]="!isStepValid(currentStep)">Create new account</button>
								 <button *ngIf="currentStep < 3 && subPlanDetails?.type === 'SUPPLIER'" mat-button class=" global-btn" style="width:100%"
										(click)="nextStep()" [disabled]="!isStepValid(currentStep)">Register Your Request</button>
								 
								<button *ngIf="currentStep === 3" type="button" mat-button class="global-btn" 
										(click)="signUp(signupFormClear)" [disabled]="!isStepValid(currentStep) || !termAndConditionCheck">Submit</button>
							  </div>
							  
							  <div class="loginOr" *ngIf="currentStep == 1" style="padding-top: 20px;">Or</div>
							  
							  <div class="donthave" *ngIf="currentStep == 1" style="display: none; gap: 10px; padding: 0px 10px;" >
								<button type="submit" mat-button class="global-btn-dark" (click)="signInWithGoogleExt()"  >
								  
								  Sign up with Google
								  <img src="../../../../../assets/images2/icons/signup-google.svg" alt="black-arrow">
							  </button>
							  
							  <button type="submit" *ngIf="currentStep == 1" mat-button class="global-btn-dark"  >
								Sign up with Email
								<img src="../../../../../assets/images2/icons/signup-email.svg" alt="black-arrow">
				  
							</button>
							  </div>
							  <div class="alreadyAcc" style="padding: 0;" *ngIf="currentStep == 1" >Already have an account? <a [routerLink]="['/login']" style="font-weight: bold; color: #FF7000;">Sign In</a></div>
							</form>
						  </div>
						</div>
						  </div>
					</div>

					<!-- PLAN-DETAILS -->
					<div class="signup_column rightSingUp" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
						fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
						<div class="rent-img"  *ngIf="currentStep == 1">
							<img src="../../../../../assets/images2/login.png" class="rent-form-img" alt="contact-form-img">
						  </div>
						  <div class="rent-img"  *ngIf="currentStep == 2">
							<img src="../../../../../assets/images2/signup2.png" class="rent-form-img" alt="contact-form-img">
						  </div>
						<div class="plan_details_box"  *ngIf="currentStep == 3">
							<ul class="plan_details_listing">
								 <div class="plan-d-icon">
									<img src="../../../../../assets/images2/smallLogo.svg" class="" alt="">
									<span class="deninf">Dental Interface 360</span>
								 </div>
								<div class="plan_box_main">
									<div class="plan_head">
										<!-- <h4>{{subPlanDetails?.name}}</h4> -->
										 <div class="subplanHeadingsec">
										<h4>{{subPlanDetails?.name}}</h4>
										<span>Your plan details</span>
									</div>
									</div>
									<div class="plan_body">
										<div class="plan_items_listing">
											<ul>
												<li *ngFor="let benefit of subPlanDetails?.benefits"><img
														src="../../../../../assets/images/icons/round_check.svg"
														alt="">{{benefit?.name}}</li>
												
											</ul>
										</div>
									</div>
									<div class="plan_footer">
								
										<div class="price">
											<h4>AUD {{subPlanDetails?.price_in_aud}} <sub>/
													{{subPlanDetails?.tenure_in_days}} Days</sub></h4>
										</div>
										<div class="price_btn">
										<!--<input type="checkbox" name="LetterNeed" *ngIf="!termAndConditionCheck"   id="termAndCondition">
											<input type="checkbox" name="LetterNeed" *ngIf="termAndConditionCheck" disabled checked   id="termAndCondition">
											-->	
											<!--<a (click)="termsPop(subPlanDetails?.terms_and_conditions)"> T&C Apply</a>-->
										</div>
									</div>
								</div>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</section>